import React from "react";
import { useNavigate } from "react-router-dom";
import {

  Rocket,
  Mail,
  CheckCircle,
  Users,
  Bell,
  Stethoscope,
  Activity,
  ArrowRight,
} from "lucide-react";
import { useState } from "react";
const PartnersPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("current");
  const [selectedCity, setSelectedCity] = useState(null);
  const [contactForm, setContactForm] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    message: "",
  });

  // Service data
  const activeLocations = [
    { name: "Delhi", icon: "📍", color: "bg-blue-100 border-blue-200" },
    { name: "Noida", icon: "📍", color: "bg-blue-100 border-blue-200" },
    { name: "Greater Noida", icon: "📍", color: "bg-blue-100 border-blue-200" },
    { name: "Faridabad", icon: "📍", color: "bg-blue-100 border-blue-200" },
    // { name: "NCR Region", icon: "📍", color: "bg-blue-100 border-blue-200" },
    { name: "Lucknow", icon: "📍", color: "bg-blue-100 border-blue-200" },
    { name: "Chandigarh", icon: "📍", color: "bg-blue-100 border-blue-200" },
    { name: "Mohali", icon: "📍", color: "bg-blue-100 border-blue-200" },
    { name: "Mumbai", icon: "📍", color: "bg-blue-100 border-blue-200" },
    { name: "Dehradun", icon: "📍", color: "bg-blue-100 border-blue-200" },
    { name: "Bengaluru*", icon: "📍", color: "bg-blue-100 border-blue-200" },
    { name: "Hyderabad*", icon: "📍", color: "bg-blue-100 border-blue-200" },
    { name: "Visakhapatnam*", icon: "📍", color: "bg-blue-100 border-blue-200" },
    { name: "Chennai*", icon: "📍", color: "bg-blue-100 border-blue-200" },
    { name: "Cochin*", icon: "📍", color: "bg-blue-100 border-blue-200" },
    { name: "Gurgaon/Manesar", icon: "📍", color: "bg-blue-100 border-blue-200" },
  ];

  const expandingLocations = [
    // { name: "Bengaluru" },
    // { name: "Hyderabad" },
    { name: "Pune" },
    // { name: "Chennai" },
    { name: "Ahmedabad" },
    { name: "Jaipur" },
    { name: "Kolkata" },
  ];

  const feasibilityItems = [
    {
      title: "Partner Hospitals",
      description: "Availability of partner hospitals in your area",
      icon: <Stethoscope className="w-5 h-5" />,
    },
    {
      title: "Lab Tie-ups",
      description: "Diagnostic lab partnerships for tests",
      icon: <Activity className="w-5 h-5" />,
    },
    {
      title: "Homecare Networks",
      description: "Local homecare service providers",
      icon: <Users className="w-5 h-5" />,
    },
    {
      title: "Emergency Support",
      description: "Feasibility of emergency response systems",
      icon: <Bell className="w-5 h-5" />,
    },
  ];

  const handleQuickContact = () => {
    navigate("/contact");
  };
  const servicesRef = React.useRef(null);
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-cyan-50 p-4 md:p-6 mt-14">
      <div className="max-w-7xl mx-auto mt-24">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Where We Currently <span className="text-maroon">Provide Care</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            AegisCare is rapidly expanding to serve families across India with
            comprehensive elderly care solutions.
          </p>
        </div>

        {/* Navigation Tabs */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          <button
            onClick={() => setActiveTab("current")}
            className={`flex items-center gap-2 px-6 py-3 rounded-full font-semibold transition-all duration-300 ${activeTab === "current"
              ? "bg-blue-600 text-white shadow-lg shadow-blue-200"
              : "bg-white text-gray-700 hover:bg-blue-50 border border-gray-200"
              }`}
          >
            <div
              className={`w-3 h-3 rounded-full ${activeTab === "current" ? "bg-green-300" : "bg-green-500"
                }`}
            />
            Active Service Locations
          </button>
          <button
            onClick={() => setActiveTab("expanding")}
            className={`flex items-center gap-2 px-6 py-3 rounded-full font-semibold transition-all duration-300 ${activeTab === "expanding"
              ? "bg-orange-600 text-white shadow-lg shadow-orange-200"
              : "bg-white text-gray-700 hover:bg-orange-50 border border-gray-200"
              }`}
          >
            <Rocket className="w-5 h-5" />
            Expanding Soon
          </button>
        
        </div>

        {/* Current Locations Tab */}
        {activeTab === "current" && (
          <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8 mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="p-2 bg-green-100 rounded-lg">
                <div className="w-4 h-4 rounded-full bg-green-500" />
              </div>
              <h2 className="text-3xl font-bold text-gray-900">
                Active Service Locations
              </h2>
            </div>
            <p className="text-gray-600 mb-8 text-lg">
              We are currently operational in these cities with full healthcare
              services and dedicated support teams.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {activeLocations.map((location, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setSelectedCity(location.name);

                    setTimeout(() => {
                      servicesRef.current?.scrollIntoView({
                        behavior: "smooth",
                      });
                    }, 100);
                  }}
                  className={`${location.color
                    } border-2 rounded-xl p-6 transition-all duration-300 hover:scale-105 hover:shadow-lg"
                      : ""
                    }`}
                >
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-2xl">{location.icon}</span>
                    <span className="px-3 py-1 bg-green-100 text-green-700 text-sm font-semibold rounded-full">
                      Active
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {location.name}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4">
                    Full service available
                  </p>
                </div>
              ))}
            </div>

            <h3 className="text-lg font-semibold text-gray-700 mt-1">
              Note: * indicates the city and its surrounding areas
            </h3>
          </div>
        )}

        {/* Expanding Locations Tab */}
        {activeTab === "expanding" && (
          <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8 mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="p-2 bg-orange-100 rounded-lg">
                <Rocket className="w-6 h-6 text-orange-600" />
              </div>
              <h2 className="text-3xl font-bold text-gray-900">
                Expanding to More Cities Soon
              </h2>
            </div>
            <p className="text-gray-600 mb-8 text-lg">
              We are in the process of onboarding trusted partners and
              caregivers in{" "}
              <span className="font-bold text-blue-600">
                all major metros and Tier-1 cities
              </span>{" "}
              across India.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {expandingLocations.map((city, index) => (
                <div
                  key={index}
                  className="border-2 border-dashed border-orange-200 rounded-xl p-6 bg-gradient-to-b from-white to-orange-50"
                >
                  <div className="flex items-center justify-between mb-4">
                    <div className="p-2 bg-orange-100 rounded-lg">
                      <Rocket className="w-5 h-5 text-orange-600" />
                    </div>
                    <span className="px-3 py-1 bg-orange-100 text-orange-700 text-sm font-semibold rounded-full">
                      Coming Soon
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">
                    {city.name}
                  </h3>

                  <button
                    onClick={handleQuickContact}
                    className="mt-4 w-full py-2 text-sm text-orange-600 font-medium hover:text-orange-700 transition"
                  >
                    Get Notified at Launch →
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PartnersPage;
